import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { house, Icon } from '../../Icon/Icon';
import './CmsBreadcrumbs.css';
import { CmsMeta } from '../cmsMeta';

type BreadcrumbPathItem = {
	name: string;
	url: string;
};

type CmsBreadcrumbsProps = {
	path?: BreadcrumbPathItem[];
};

export const CmsBreadcrumbs = ({ path = [] }: CmsBreadcrumbsProps): JSX.Element => {
	const normalizedPath = Array.isArray(path)
		? path
				.filter((item) => item && typeof item === 'object')
				.map((item) => ({
					name: typeof item.name === 'string' ? item.name : '',
					url: typeof item.url === 'string' ? item.url.replace(/^\/+/, '') : '',
				}))
		: [];

	/*
	 * Separators as elements, not loose text: a browser translating the page replaces text nodes
	 * with its own, and react then fails to remove the node it thinks is there. The same shape as
	 * the site's own breadcrumbs, for the same reason.
	 */
	return (
		<div className="breadcrumbs">
			<Link to="/">
				<Icon shape={house} size={14} />
			</Link>
			<span className="crumb-separator"> / </span>
			{normalizedPath.map((e, i) => (
				<Fragment key={i}>
					{i ? <span className="crumb-separator"> / </span> : null}
					<Link className={i === normalizedPath.length - 1 ? 'last-crumb' : ''} to={'/' + e.url}>
						{e.name}
					</Link>
				</Fragment>
			))}
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		"The trail of links above a page's heading, starting with a house icon for the front page. `path` lists each step after it with its name and its path on the site, without a leading slash; the last step is the page itself.",
	example: [
		'CmsBreadcrumbs',
		{
			path: [
				{
					name: 'Varumärken',
					url: 'varumarken',
				},
				{
					name: 'Leitz',
					url: 'varumarken/leitz',
				},
				{
					name: 'Leitz Ergonomi Hemma',
					url: 'kampanjer/leitz-ergonomi-hemma',
				},
			],
		},
	],
};
